// normalize 4.2.0
// IE < 10 and mobile styles have been removed

export default {
  '@global': {
    html: {
      fontFamily: 'sans-serif',
      lineHeight: 1.15,
      '-ms-text-size-adjust': '100%',
      '-webkit-text-size-adjust': '100%'
    },
    body: {
      margin: 0
    },
    'article, aside, footer, header, nav, section': {
      display: 'block'
    },
    hr: {
      boxSizing: 'content-box',
      height: 0,
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent',
      '-webkit-text-decoration-skip': 'objects'
    },
    'a:active, a:hover': {
      outlineWidth: 0
    },
    'b, strong': {
      fontWeight: 'bolder'
    },
    'svg:not(:root)': {
      overflow: 'hidden'
    },
    'button, input, optgroup, select, textarea': {
      fontFamily: 'sans-serif',
      fontSize: '100%',
      lineHeight: 1.15,
      margin: 0
    },
    'button, input': {
      overflow: 'visible'
    },
    'button, select': {
      textTransform: 'none'
    },
    'button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner': {
      borderStyle: 'none',
      padding: 0
    },
    'button:-moz-focusring, [type="button"]:-moz-focusring, [type="reset"]:-moz-focusring, [type="submit"]:-moz-focusring': {
      outline: '1px dotted ButtonText'
    },
    '[type="checkbox"], [type="radio"]': {
      boxSizing: 'border-box',
      padding: 0
    },
    '[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button': {
      height: 'auto'
    },
    '[type="search"]': {
      '-webkit-appearance': 'textfield',
      outlineOffset: -2
    },
    '[type="search"]::-webkit-search-cancel-button, [type="search"]::-webkit-search-decoration': {
      '-webkit-appearance': 'none'
    },
    '::-webkit-file-upload-button': {
      '-webkit-appearance': 'button',
      font: 'inherit'
    },
    '[hidden]': {
      'display': 'none'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/normalize.js